import React, { useEffect, useState } from "react"
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import ReactImageGallery from "react-image-gallery";

const ExteriorImage = (props) => {

    const [exteriorimage, setExteriorImage] = useState([])
    let navigate = useNavigate();
    const [exteriorimageloading, setExterorImageLoading] = useState(false)


    async function fetchExteriorImage() {
        //setExteriorImage(true);
        try {
            const res = await axios.get("assets/data/exterior.json");
            if (res.data) {
                setExteriorImage(res.data);
            }
        } catch (error) {
            setExteriorImage(false);
        }
    }
    const formattedImages = exteriorimage.map((image) => ({
        original: image.exterior_image_path,
        thumbnail: image.exterior_image_path, // You can use the same path for thumbnail, or provide a different one
        description: `Image ${image.id}`, // Optional: Add a description
        // Add any other properties if needed
    }));
    const desktopGalleryProps = {
        items: formattedImages,
        infinite: true,
        thumbnailPosition: 'bottom',
        showFullscreenButton: false,
        showPlayButton: false,
        className: "img-fluid custom-gallery-desktop"
    };

    const mobileGalleryProps = {
        items: formattedImages,
        infinite: true,
        thumbnailPosition: 'right', // Change to the desired position for mobile
        showFullscreenButton: false,
        showPlayButton: false,
        className: "img-fluid custom-gallery-mobile"
    };
    useEffect(() => {
        fetchExteriorImage();
    }, [])
    return (
        <>
            {
                props.imageCaraousel
                    ?
                    <div className="carouselBox">
                        <div className="carouselImage">
                            {
                                window.innerWidth > 1023 ?
                                    <ReactImageGallery {...desktopGalleryProps} className="custom-gallery" />
                                    :
                                    <ReactImageGallery {...mobileGalleryProps} className="custom-gallery" />
                            }
                            <button onClick={() => { props.setImageCaraousel(false) }} className="cusocialBackBtn">
                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35">
                                    <defs>
                                        <clipPath id="clip-X">
                                            <rect width="35" height="35" />
                                        </clipPath>
                                    </defs>
                                    <g id="X" clip-path="url(#clip-X)">
                                        <g id="Ellipse_27" data-name="Ellipse 27" fill="none" stroke="#fff" strokeWidth="3">
                                            <circle cx="17.5" cy="17.5" r="17.5" stroke="none" />
                                            <circle cx="17.5" cy="17.5" r="16" fill="none" />
                                        </g>
                                        <g id="Group_1146" data-name="Group 1146" transform="translate(9.557 10.336)">
                                            <line id="Line_15" data-name="Line 15" x2="15" y2="16" transform="translate(0.443 -0.336)" fill="none" stroke="#dc6b33" strokeWidth="3" />
                                            <line id="Line_16" data-name="Line 16" y1="16" x2="15" transform="translate(0.443 -0.336)" fill="none" stroke="#dc6b33" strokeWidth="3" />
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <h3 className="interiorHeading carouselThumbail">Exterior</h3>
                        </div>
                    </div>
                    :
                    ""
            }

        </>
    )
}
export default ExteriorImage;